module.exports = __webpack_public_path__ + "img/IMG_8157_L_BlackMatted.593f919e.jpg";